"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentSubscriptionsSelector = void 0;

var currentSubscriptionsSelector = function currentSubscriptionsSelector(_ref) {
  var currentSubscriptions = _ref.currentSubscriptions;
  return currentSubscriptions;
};

exports.currentSubscriptionsSelector = currentSubscriptionsSelector;